



import { Component, Vue, Watch } from 'vue-property-decorator';
import { Action } from 'vuex-class';

/**
 * API
 */
import settingsAPI from '@/api/settings';

/**
 * Components
 */
import SettingsEditor from './components/Editor.vue';

/**
 * Types
 */
import { SettingsCategories } from '@/api/settings';

/**
 * Page des configurations basiques.
 */
@Component({ components: { SettingsEditor } })
export default class SettingsPage extends Vue {
	/** Attributs */

	/** Méthodes */
	fetchSettings() {
		return settingsAPI.getAllSettings(SettingsCategories.PARAMETER);
	}

	saveSettings(formData: FormData) {
		return settingsAPI.saveAllSettings(formData);
	}
}
